import { state } from './state'

const KEY = 'okane.theme'

/** Dark or light, as this device is set: what a first visit starts in. */
const systemTheme = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'

/**
 * The theme, per browser. The first visit takes the system's and keeps it, so
 * from then on it is simply dark or light and the header's switch flips it.
 * `system` — a choice Settings used to offer — is settled the same way.
 */
function stored() {
  let theme = null
  try {
    theme = localStorage.getItem(KEY)
  } catch {
    // No storage: the system's, every time.
  }
  if (theme === 'dark' || theme === 'light') return theme
  theme = systemTheme()
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // Nothing to keep it in.
  }
  return theme
}

function paint(theme) {
  const dark = theme === 'dark'
  document.documentElement.classList.toggle('dark', dark)
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', dark ? '#080d11' : '#f4f6f8')
}

/** Runs before mount so there is never a flash of the wrong theme. */
export function applyStoredTheme() {
  paint(stored())
}

export function setTheme(theme) {
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // It still changes for as long as the page is open.
  }
  state.settings.theme = theme
  paint(theme)
}

export const currentTheme = () => stored()
